module.exports = {"customer":"Klant","customers":"Klanten","name":"Naam","firstname":"Voornaam","lastname":"Familienaam","email":"E-mail","list":{"title":"Klanten"},"manage":{"edit":"Klant gegevens wijzigen","create":"Klant aanmaken"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/customer.json
// module id = wgcx
// module chunks = 9